var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { R as RestResult } from "../RestServiceBase-3b5c02c9.js";
class FakeRestResult extends RestResult {
  constructor(data, failureMessage) {
    super(data, "", 0);
    __publicField(this, "_thisData");
    __publicField(this, "_failureMessage");
    this._thisData = data;
    this._failureMessage = failureMessage;
  }
  ensureSuccess() {
    if (!this.isSuccessful()) {
      const error = new Error(`The result wasn't successful: ${this._failureMessage}`);
      throw error;
    }
  }
  getSuccessData() {
    this.ensureSuccess();
    return this._thisData;
  }
  isSuccessful() {
    return !this._failureMessage;
  }
}
function fakeApiCall(data, failureMessage) {
  return __async(this, null, function* () {
    const restResult = new FakeRestResult(data, failureMessage);
    return new Promise((resolve) => resolve(restResult));
  });
}
function fakeDelay(ms) {
  return __async(this, null, function* () {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  });
}
export {
  FakeRestResult,
  fakeApiCall,
  fakeDelay
};
//# sourceMappingURL=FakeRestResult.js.map
